declare namespace $ {

	type $mol_view__sub_shm_ba_search_settings_1 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_select__value_shm_ba_search_settings_2 = $mol_type_enforce<
		ReturnType< $shm_ba_search_settings['search_mode'] >
		,
		ReturnType< $mol_select['value'] >
	>
	type $mol_select__dictionary_shm_ba_search_settings_3 = $mol_type_enforce<
		ReturnType< $shm_ba_search_settings['mode_options'] >
		,
		ReturnType< $mol_select['dictionary'] >
	>
	type $mol_check_box__title_shm_ba_search_settings_4 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_check_box['title'] >
	>
	type $mol_check_box__checked_shm_ba_search_settings_5 = $mol_type_enforce<
		ReturnType< $shm_ba_search_settings['search_case_sensitive'] >
		,
		ReturnType< $mol_check_box['checked'] >
	>
	type $mol_view__sub_shm_ba_search_settings_6 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	export class $shm_ba_search_settings extends $mol_view {
		Title( ): $mol_view
		search_mode( next?: string ): string
		mode_options( ): ({ 
			'fts': string,
			'substring': string,
		}) 
		Mode_select( ): $mol_select
		search_case_sensitive( next?: boolean ): boolean
		Case_sensitive( ): $mol_check_box
		description( ): string
		Description( ): $mol_view
		sub( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=settings.view.tree.d.ts.map